import { avlFalcor } from "../avl-falcor"

const avlFalcorWrapper = Component => avlFalcor(Component);

export default avlFalcorWrapper;
